<template>
  <div class="search-bar-news">
    <div class="container-news">
      <div class="input-group searchbox-news">
        <q-input
          dense
          outlined
          v-model="searchText"
          label="Zoeken"
          class="search-input"
          @keydown.enter="searchNews()"
        >
          <template v-slot:append>
            <q-icon name="search" class="search-icon" />
          </template>
        </q-input>
        <a
          style="text-decoration: none"
          class=" operators-help"
          href="https://www.vindsubsidies.nl/faq-database/"
          target="_blank"
        >
          Meer informatie over zoeken met operatoren
        </a>
      </div>
      <q-btn
        text-color="#0a1f8f"
        class="button-search-news"
        @click="searchNews()"
        no-caps
      >
        <q-icon name="search" class="search-icon" />
        <span style="font-weight: bold">Zoeken</span>
      </q-btn>
    </div>
  </div>
</template>

<script>
import store from '../../store/index.js';
import { computed } from 'vue';

import NewsUtils from '../../utils/news';

export default {
  setup() {
    const dateFrom = computed({
      get: () => store.state.newsSearch.dateFrom,
    });
    const dateTo = computed({
      get: () => store.state.newsSearch.dateTo,
    });

    const audienceTags = computed({
      get: () => store.state.newsSearch.selectedAudiences,
    });

    const locationsTags = computed({
      get: () => store.state.newsSearch.selectedLocations,
    });

    const purposesTags = computed({
      get: () => store.state.newsSearch.selectedPurposes,
    });

    const schemesTags = computed({
      get: () => store.state.newsSearch.selectedSchemeTypes,
    });

    //This is just hidden for now, don't remove it
    /*
    const industriesTags = computed({
      get: () => store.state.newsSearch.selectedIndustries,
    });
    */

    const searchNews = async () => {
      store.commit('newsSearch/createOrganisationsIncludeString');
      store.commit('newsSearch/createOrganisationsExcludeString');
      await NewsUtils.searchNews();
    };

    const orgsIncludeString = computed({
      get: () => store.state.newsSearch.organisationsIncludeString,
    });

    const orgsExcludeString = computed({
      get: () => store.state.newsSearch.organisationsExcludeString,
    });

    const searchText = computed({
      get: () => store.state.newsSearch.searchText,
      set: (val) => store.commit('newsSearch/updateSearchText', val),
    });

    const allNews = computed({
      get: () => store.state.news.allNews,
    });

    return {
      allNews,
      searchText,
      //This is just hidden for now, don't remove it
      //industriesTags,
      schemesTags,
      purposesTags,
      audienceTags,
      locationsTags,
      searchNews,
      dateFrom,
      dateTo,
      orgsIncludeString,
      orgsExcludeString,
    };
  },
};
</script>
